export default {
  // AI component (AIIntegration)
  'ai.integration.ref': 'Reference',
  'ai.integration.firstLastFrame': 'First/Last frame',
  'ai.integration.firstFrame': 'First frame',
  'ai.integration.lastFrame': 'End frame',
  'ai.integration.promptPlaceholder':
    'Describe the visuals and motion. Use @ to reference images or videos.',
  'ai.integration.panelSpec': 'Parameters',
  'ai.integration.generate.count': 'Generate {count}',
  'ai.integration.generate.option': '{count}',
  'ai.integration.generate.costTooltip': 'Cost {points} credits',
  'ai.integration.modelPlaceholder': 'Select model',
  'ai.integration.submitSuccess': 'Generation task submitted',
  'ai.integration.submitFailed': 'Submit failed. Please try again.',
  'ai.integration.submitNoWorkspace': 'No workspace found. Please sign in first.',
  'ai.integration.submitNoModel': 'Please select a model first.',
  'ai.integration.submitting': 'Submitting...',
};

